<template>
  <vv-box :title="$t('userAccount.language')" :unpadded="true">
    <div class="container">
      <vv-form-select-input class="personnalInformation-language" already-translated v-model="locale" :options="availableLocales"/>
      <vv-button class="validate-button" @click="save">{{ $t('forms.validate') }}</vv-button>
    </div>
  </vv-box>
</template>

<script>
import VvBox from '@/components/common/VvBox'
import { UPDATE_USER_INFORMATIONS } from '@/store/modules/user/types'
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import { VvButton } from '@/components/common'
import VvFormSelectInput from '@/components/common/forms/VvFormSelectInput'

export default {
  name: 'Language',
  components: { VvBox, VvButton, VvFormSelectInput },
  mixins: [userMixin, remoteConfigMixin],
  data() {
    return {
      locale: '',
    }
  },
  computed: {
    availableLocales() {
      const languages = this.remoteConfig.getString('languages')

      if (languages) {
        return languages
          .split('|')
          .map(language => ({ value: language, text: this.$t(`languages.${language}`) }))
      }

      return []
    }
  },
  mounted() {
    if (this.user && this.user.language) {
      this.locale = this.user.language

      return
    }

    const browserLocale = navigator.language || navigator.browserLanguage
    const localeMatch = this.availableLocales.find(({ value }) => value === browserLocale)

    this.locale = localeMatch ? localeMatch.value : 'fr-FR'
  },
  methods: {
    async save() {
      await this.$store.dispatch(UPDATE_USER_INFORMATIONS, {
        language: this.locale
      })

      await this.$store.dispatch('SYNC_DATA', { locale: this.locale })

      const i18nLocaleMapping = {
        'en-US': 'en',
        'fr-FR': 'fr'
      }

      this.$root.$i18n.locale = i18nLocaleMapping[this.locale]
      if (this.$validator.dictionary.hasLocale(i18nLocaleMapping[this.locale])) {
        this.$validator.localize(i18nLocaleMapping[this.locale]);
      } else {
        import(`vee-validate/dist/locale/${i18nLocaleMapping[this.locale]}`).then(locale => {
          this.$validator.localize(i18nLocaleMapping[this.locale], locale);
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 17px 17px 23px 17px;
  display: flex;
  flex-direction: column;
}
.validate-button {
  width: 200px;
  margin-left: 40%;
  @media screen and (max-width: 719px) {
    width:76%; 
    margin-left:0;  
  }
}

</style>
